import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ShieldCheck } from "lucide-react";

// One-time credential display. Values live only in React state passed by the parent; nothing is written to
// localStorage/sessionStorage/URL/history, and print CSS redacts the digits. There is no re-reveal path — reset only.
export function OneTimeCredentials({ creds, staffName, onClose }) {
  if (!creds) return null;
  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-sm" data-testid="one-time-credentials">
        <style>{`@media print { [data-otc-secret] { visibility: hidden; } [data-otc-secret]::after { content: "REDACTED"; visibility: visible; } }`}</style>
        <DialogHeader>
          <DialogTitle className="font-head flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-emerald-500" /> PINs issued{staffName ? ` · ${staffName}` : ""}</DialogTitle>
          <DialogDescription data-testid="otc-notice">{creds.notice || "Save these PINs now. They will not be shown again."}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {creds.login_pin && <Row label="Login PIN (4 digits · Quick Login / switch user)" value={creds.login_pin} testid="otc-login-pin" />}
          {creds.authorization_pin && <Row label="Authorization PIN (6 digits · approvals only)" value={creds.authorization_pin} testid="otc-authorization-pin" />}
          <p className="text-[11px] text-muted-foreground">A Login PIN never approves anything; an Authorization PIN never logs anyone in. If a PIN is lost, reset it — it cannot be viewed again.</p>
          <Button onClick={onClose} className="w-full" data-testid="otc-done">I have saved these PINs</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

const Row = ({ label, value, testid }) => (
  <div className="rounded-xl border border-border p-3">
    <p className="text-[10px] uppercase tracking-wider text-muted-foreground">{label}</p>
    <p className="mono font-bold text-2xl tracking-[0.3em]" data-otc-secret data-testid={testid}>{value}</p>
  </div>
);
